import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AceEditor from "react-ace";
import Toggle from "@atlaskit/toggle";
import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/mode-text";
import "ace-builds/src-noconflict/theme-dawn";
import { getAceEditorTheme } from "../../../../../../common/utils/aceEditorTheme";

const DEFAULT_RESPONSE_HEADERS = JSON.stringify(
  {
    "Content-Type": "application/json",
    Connection: "keep-alive",
  },
  null,
  2
);

const MockResponse = ({ action, updateCallback }) => {
  const [headers, setHeaders] = useState("");
  const [data, setData] = useState("");
  const [enabled, setEnabled] = useState(false);
  const render = useSelector((state) => state.integration.render);

  useEffect(() => {
    setHeaders(action?.mockResponseHeaders ?? "");
    setData(action?.mockResponseData ?? "");
    setEnabled(Boolean(action?.mockResponseEnabled));
  }, [action, render]);

  const onToggle = () => {
    if (!action) {
      return;
    }
    const next = !enabled;
    action.mockResponseEnabled = next;
    if (next && !action.mockResponseHeaders) {
      action.mockResponseHeaders = DEFAULT_RESPONSE_HEADERS;
      setHeaders(DEFAULT_RESPONSE_HEADERS);
    }
    setEnabled(next);
    updateCallback?.();
  };

  const handleChange = (setter, field) => (value) => {
    setter(value);
    if (!action) {
      return;
    }
    action[field] = value;
    updateCallback?.();
  };

  return (
    <div className="ihub-mock-response">
      <div className="ihub-response-file-toggle">
        <Toggle id="mock-response-toggle" size="regular" isChecked={enabled} onChange={onToggle} />
        <span style={{ position: "relative", top: "-4px" }}>Mock response</span>
      </div>
      {enabled && (
        <>
          <p className="ihub-action-tab-description">Provide mock HTTP details used when the action is stubbed.</p>
          <div className="ihub-mock-response-section">
            <label htmlFor="mock-response-headers">Mock response headers</label>
            <AceEditor
              id="mock-response-headers"
              className="ihub-action-body-editor"
              mode="json"
              theme={getAceEditorTheme()}
              onChange={handleChange(setHeaders, "mockResponseHeaders")}
              name="mock-response-headers"
              editorProps={{ $blockScrolling: true }}
              value={headers}
              showPrintMargin={false}
              width="100%"
            />
          </div>
          <div className="ihub-mock-response-section">
            <label htmlFor="mock-response-data">Mock response data</label>
            <AceEditor
              id="mock-response-data"
              className="ihub-action-body-editor"
              mode="json"
              theme={getAceEditorTheme()}
              onChange={handleChange(setData, "mockResponseData")}
              name="mock-response-data"
              editorProps={{ $blockScrolling: true }}
              value={data}
              showPrintMargin={false}
              width="100%"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default MockResponse;
